import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class DeductionItemDispose extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        salaryInfoList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetDeductionItemDisposeList(pageCount)
    }

    GetDeductionItemDisposeList = (row) => {
        const { query } = this.state
        Tyan.doPostEvent('GetDeductionItemDisposeList', {
            data: { row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, salaryInfoList, totalCount }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, salaryInfoList, totalCount })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetDeductionItemDisposeList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetDeductionItemDisposeList(pageCount)
    }

    handleChildTap = ({ id }) => {
        location.hash = `/QYWX/DeductionItemDisposeDetail/${id}`
        return
    }

    render() {
        const { salaryInfoList, errorMessage, query, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!salaryInfoList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} />
                <ListItem listData={salaryInfoList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default DeductionItemDispose